module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-carousel', {
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "trigger": "click",
      "height": _vm.imgHeight + 'px'
    }
  }, _vm._l((_vm.bannerLists), function(item) {
    return _c('el-carousel-item', {
      key: item.id
    }, [_c('img', {
      ref: _vm.imgHeight,
      refInFor: true,
      staticClass: "bannerImg",
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })])
  }), 1), _vm._v(" "), _c('ul', {
    staticClass: "homeList"
  }, _vm._l((_vm.productListData), function(item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isMasking),
        expression: "isMasking"
      }],
      key: index,
      staticClass: "homeMain"
    }, [_c('div', {
      staticClass: "homeImg",
      on: {
        "click": function($event) {
          return _vm.detailsRouter(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": ("" + _vm.imgSrcPrefix + (item.productImg)),
        "alt": item.categoryName
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "homeTit"
    }, [_c('h2', {
      class: item.productName.length > 6 ? 'homeTit-title2' : 'homeTit-title'
    }, [_vm._v("\n          " + _vm._s(item.productName) + "\n        ")]), _vm._v(" "), (item.productClassification == 1) ? _c('div', [_c('p', [_vm._v("仅对长期合作客户开放")]), _vm._v(" "), _c('p', [_vm._v("折扣利率、资料简化")]), _vm._v(" "), _c('p', [_vm._v("融资比例上限提高")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 2) ? _c('div', [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("企业应收转让")]), _vm._v(" "), _c('p', [_vm._v("融资速度快")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 3) ? _c('div', [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("买方确权应付")]), _vm._v(" "), _c('p', [_vm._v("利率相对优惠")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 4) ? _c('div', [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("仅对战略合作买方体系开放")]), _vm._v(" "), _c('p', [_vm._v("解决立账期间短时资金需求")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 5) ? _c('div', [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("提供票据融资咨询服务")]), _vm._v(" "), _c('p', [_vm._v("多方合作、渠道无忧")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 6) ? _c('div', [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("融资比例100%")]), _vm._v(" "), _c('p', [_vm._v("融资成本较低")])]) : _vm._e(), _vm._v(" "), _c('a', {
      class: item.userName,
      on: {
        "click": function($event) {
          return _vm.detailsRouter(item)
        }
      }
    }, [_vm._v("产品详情")])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b2928ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = 1073
// module chunks = 1